module.exports = __webpack_public_path__ + "img/image_upload_placeholder.d6ea53fa.jpg";